export default [
  {
    path: "entity-group",
    name: "settings-entity-group",
    component: () =>
      import("@/views/settings/views/entity-group/EntityGroup.vue"),
    meta: {
      section: 4,
      pageTitle: "entity group",
      breadcrumb: [
        {
          text: "list",
        },
      ],
    },
  },
];
